const IdAssigner = (tagName: any) => {
  const myIds: any = {};
  const tagList = document.getElementsByTagName(tagName);
  let labelLinked;
  for (let j = 0; j < tagList.length; ++j) {
    const el = tagList[j];
    let idToAssign: string = '';
    if (tagName === 'input') {
      labelLinked = tagList[j].__vue__?.$parent.label || tagList[j].__vue__?.$parent.$parent.label || tagList[j].getAttribute('placeholder') || tagList[j].getAttribute('type') || tagList[j].getAttribute('name');
      idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
    } else if (tagName === 'select') {
      labelLinked = tagList[j].__vue__?.$parent.label || tagList[j].__vue__?.$parent.$parent.label || tagName;
      idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
    } else if (tagName === 'button') {
      labelLinked = tagList[j].innerText || tagList[j].getAttribute('title') || tagList[j].getAttribute('aria-label');
      if (tagList[j].parentElement.parentElement.previousElementSibling?.tagName === 'LABEL' && !labelLinked) {
        labelLinked = tagList[j].parentElement.parentElement.previousElementSibling.innerText;
      } else if (!labelLinked) {
        labelLinked = tagList[j].parentElement.parentElement.innerText?.split('\n')[0] || tagName;
      }
      idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
    } else if (tagName === 'div') {
      if (tagList[j].classList.contains('checkbox-select__trigger')) {
        labelLinked = tagList[j].previousSibling.innerText || 'checkboxdropdown';
        idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
      }
    } else if (tagName === 'iframe') {
      if (tagList[j].title.includes('Rich')) {
        labelLinked = tagList[j].parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.previousSibling?.innerText
          || tagName;
        idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
      }
    } else if (tagName === 'h4') {
      labelLinked = `${tagList[j].innerText}h4`;
      idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase() || tagName;
    } else if (tagName === 'span') {
      labelLinked = tagList[j].innerText ? tagList[j].innerText : tagName;
      idToAssign = labelLinked?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase();
    } else {
      idToAssign = tagList[j].innerText?.split(' ').join('').replaceAll(/[^a-z0-9]/gi, '').toLowerCase() || tagName;
    }

    if (idToAssign) {
      if (myIds[idToAssign] || myIds[idToAssign] === 0) {
        myIds[idToAssign] += 1;
        idToAssign += myIds[idToAssign];
      } else {
        myIds[idToAssign] = 0;
      }
      if ((!tagList[j].id || tagList[j].id.includes('__BV')) && (idToAssign !== 'NaN' && idToAssign)) { tagList[j].id = idToAssign; }
    }
  }
};

const elementNames = [ 'input', 'a', 'option', 'select', 'button', 'div', 'iframe', 'h4', 'span' ];

export const assignIds = () => {
  if (document) { elementNames.map((name) => IdAssigner(name)); }
};
